import{sendCustomEvent as o}from"@perxis-auto/shared";import{EVENTS_CHANNEL as t}from"../constants/events.js";const r=(r,s,e)=>{o(t,r,s,e)};export{r as sendEvent};
//# sourceMappingURL=sendEvent.js.map
